module.exports = ":host{height:100%;width:100%;font-size:12px;display:block}:host span.required{color:red}"